<app-documents
  [productId]="productId"
  (goToDocuments)="openDocuments()"
  *restrictTo="'VIEW_DOWNLOAD_DOCUMENTS'"
></app-documents>

<app-dc-pane class="lifecycle" [lightBackground]="true" [xScrollMinWidth]="650">
  <ng-container class="heading">Lifecycle</ng-container>
  <app-dc-timeline [timelineData]="timelineData"></app-dc-timeline>
</app-dc-pane>

<app-dc-pane
  class="schedule"
  [lightBackground]="true"
  [tableContainer]="true"
  [noScroll]="true"
>
  <ng-container class="heading">Coupon Schedule</ng-container>
  <app-dc-table
    #table
    class="no-footer"
    [columns]="columns"
    [rows]="schedules"
    [messages]="messages"
    [sort]="sortOrder"
  ></app-dc-table>
</app-dc-pane>
